import { AxiosResponse } from "axios";
import { useEffect, useRef, useState } from "react";
import { connect, useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import Select from "react-select";
import { toast } from "react-toastify";
import useLang from "Shared/hooks/useLanguage";
import { styles } from "Utils/Common";
import { FindIndex } from "Utils/Common/CommonMethods";
import { IPropsGroupSelect } from "../../Interface/SingleRequisition";
import {
  setRequisitionData,
  setSelectedRequisitionData,
} from "../../Redux/Actions/Pages/Requisition";
import RequisitionType from "../../Services/Requisition/RequisitionTypeService";
import { assignFormValues, clearSignature } from "../../Utils/Auth";
import {
  collectorNameOptionsAdd,
  extractDropDownSelectedValue,
  setDropDownValue,
} from "../../Utils/Common/Requisition";
import Checkbox from "../Common/Input/Checkbox";
import Input from "../Common/Input/Input";
import FacilityDropdown from "./FacilityDropdown";
import Popup from "./Popup";
import ProviderDropdown from "./ProviderDropdown";

const GroupedSelect: React.FC<IPropsGroupSelect> = ({
  fields,
  isShown,
  setIsShown,
  inputs,
  dependenceyControls,
  index,
  errorFocussedInput,
  setInputs,
  setInfectiousData,
  setPhysicianId,
  setErrorFocussedInput,
  props,
}) => {
  const { t } = useLang();
  const location = useLocation();
  const dispatch = useDispatch();
  const _adminType = useSelector(
    (state: any) =>
      state?.Reducer?.selectedTenantInfo?.infomationOfLoggedUser?.portalType
  );

  const params = new URLSearchParams(window.location.search);
  const workflowId = params.get("workflowId");
  const requisitionId = location?.state?.reqId;

  useEffect(() => {
    props.Inputs[props.index]?.fields?.forEach((field: any) => {
      if (field?.systemFieldName === "PhysicianID") {
        setPhysicianList(field?.options);

        if (!field?.defaultValue && requisitionId) {
          setExpression(field.validationExpression);
          setProviderNotRequired(true);
        }
      }
    });
  }, []);

  const ref = useRef<any>(null);
  const [selectedDropDownValue, setSelectedDropDownValue] = useState<any>({});
  const [physicianList, setPhysicianList] = useState([]);
  const [open, setOpen] = useState<any>(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  const [providerNotRequired, setProviderNotRequired] = useState(false);
  const [expression, setExpression] = useState("");

  const handleChange = (e: any) => {
    if (e.target.checked) {
      setProviderNotRequired(true);
      props.Section.fields.map((field: any) => {
        if (field.systemFieldName === "PhysicianID") {
          setExpression(field.validationExpression);
          field.defaultValue = "";
          field.selectedText = "";
          field.validationExpression = "";
        }
      });
      setSelectedDropDownValue((preVal: any) => {
        return {
          ...preVal,
          selectedProvider: "",
        };
      });
    } else {
      setProviderNotRequired(false);
      props.Section.fields.map((field: any) => {
        if (field.systemFieldName === "PhysicianID") {
          field.validationExpression = expression;
        }
      });
    }
  };

  useEffect(() => {
    getPreFilledFormValuesToEditfacility();
  }, []);

  const LoadRequisitionSection = (obj: any) => {
    if (obj.insuranceTypeId === undefined || obj.insuranceTypeId === null)
      return;
    window.dispatchEvent(new Event("storage"));
    RequisitionType?.LoadReqSectionByFacilityIDandInsuranceId(obj)
      .then((res: AxiosResponse) => {
        if (Array.isArray(res.data)) {
          res.data.forEach((requisitionNameLevel: any) => {
            requisitionNameLevel.sections.forEach((sectionsLevel: any) => {
              sectionsLevel.fields.forEach((fieldsLevel: any) => {
                fieldsLevel.singleRequsition = true;
                if (Array.isArray(fieldsLevel.panels)) {
                  fieldsLevel.panels.forEach((panel: any) => {
                    if (Array.isArray(panel?.testOptions)) {
                      panel.testOptions.sort((a: any, b: any) => {
                        const subDiff = (a.subPanelSortOrder ?? 0) - (b.subPanelSortOrder ?? 0);
                        return subDiff !== 0 ? subDiff : (a.testSortOrder ?? 0) - (b.testSortOrder ?? 0);
                      });
                    }
                  });
                }
              });
            });
          });
          setInfectiousData(res.data);
          if (requisitionId) {
            let objToSend: any;
            let ReqIdArray: any = [];
            let ReqNameArray: any = [];
            res.data.map((item: any) => {
              ReqIdArray.push(item?.reqId);
              ReqNameArray.push(item?.requistionName);
            });
            objToSend = {
              requsitionId: ReqIdArray,
              requisitionName: ReqNameArray,
            };
            dispatch(setSelectedRequisitionData(objToSend));
          }
          dispatch(
            setRequisitionData({
              reqRequestData: res?.data,
            })
          );
          ref.current.scrollIntoView({ behavior: "smooth" });
        } else {
          setInfectiousData([]);
          toast.error(res.data.message);
        }
      })
      .catch((err: any) => {
        console.trace("err");
      });
  };
  const ProviderLookup = async (e: any) => {
    await RequisitionType.getProvidersList(e)
      .then((res: any) => {
        setPhysicianList(res?.data);
        getPreFilledFormValuesToEdit(res?.data);
      })
      .catch((err: any) => {
        console.trace(err);
      });
  };
  const getPreFilledFormValuesToEdit = (physicians: any) => {
    let physicianInfo = fields?.find(
      (info: any) => info?.systemFieldName == "PhysicianID"
    );
    const selectedProvider = physicians?.find(
      (item: any) => item?.value === physicianInfo?.defaultValue
    );
    onProviderSelect(selectedProvider);
  };
  const getPreFilledFormValuesToEditfacility = () => {
    let selectedFacility = extractDropDownSelectedValue(fields, "FacilityID");
    onFacilitySelect(selectedFacility);
  };

  const onFacilitySelect = async (e: any) => {
    const facilityId = parseInt(e?.value);
    if (isNaN(facilityId)) return;

    try {
      // Clone inputs
      const updatedInputs = [...inputs];

      // Find indices
      const physicianIndex = updatedInputs.findIndex((i) => i.sectionId === 13);
      const patientIndex = updatedInputs.findIndex((i) => i.sectionId === 14);

      // Clear physician signature fields
      if (physicianIndex !== -1) {
        updatedInputs[physicianIndex].fields?.forEach((field: any) => {
          field.defaultValue = "";
          field.signatureText = "";
        });
        clearSignature();
      }

      // Utility to check if facilityId is in section's facilities list
      const updateSectionSelection = (index: number) => {
        if (
          index !== -1 &&
          Array.isArray(updatedInputs[index]?.sectionConfiguration?.facilities)
        ) {
          const isSelected =
            updatedInputs[index].sectionConfiguration.facilities.includes(
              facilityId
            );
          updatedInputs[index].isSelected = isSelected;
        }
      };

      // Update selection for both sections
      updateSectionSelection(patientIndex);
      updateSectionSelection(physicianIndex);

      setInputs(updatedInputs);

      // Dispatch to store
      dispatch(setRequisitionData({ facilityId }));

      // Trigger supporting functions
      ProviderLookup(facilityId);
      getCollectorNameList(e?.value);
      localStorage.setItem("facilityID", facilityId.toString());

      // Assign form values
      const newInputsPromise = assignFormValues(
        inputs,
        index,
        undefined,
        0,
        facilityId,
        false,
        false,
        false,
        undefined,
        undefined,
        undefined,
        e.label,
        setInputs
      );

      // Conditionally await and set new inputs
      if (!requisitionId) {
        const newInputs = await newInputsPromise;
        setInputs(newInputs);
      }

      // Load requisition if insuranceId exists
      const insuranceTypeId = localStorage.getItem("insurnceID");
      const requisitionOrderId = location?.state?.orderid;

      if (insuranceTypeId) {
        const obj = {
          facilityId,
          insuranceTypeId,
          pageId: 6,
          requisitionId,
          requisitionOrderId,
          workflowId,
        };
        LoadRequisitionSection(obj);
        if (requisitionId) {
          LoadRequisitionSection(obj); // this call looks redundant, but kept as per original logic
        }
      }

      // Update dropdown selection
      setSelectedDropDownValue((prev: any) => ({
        ...prev,
        selectedFacility: e,
        selectedProvider: "",
      }));
    } catch (error) {
      console.error("Error in onFacilitySelect:", error);
    }
  };

  const onProviderSelect = async (e: any) => {
    if (!e?.value) return;
    // if (!facilitySelect && _adminType !== 2 && !requisitionId) {
    //   const response = await RequisitionType.GetFacilityByProviderId(e?.value);
    //   setFacilities(response?.data?.facilities);
    //   const FacilityInput = FacilityAdd(inputs, response?.data?.facilities);
    //   let FacilityInputCopy: any = [...FacilityInput];
    //   setInputs(FacilityInputCopy);
    // }
    let newInputs = assignFormValues(
      inputs,
      index,
      undefined,
      1,
      e.value,
      false,
      false,
      false,
      undefined,
      undefined,
      undefined,
      e.label,
      setInputs
    );

    if (!requisitionId) {
      newInputs?.then((res) => {
        setInputs(res);
      });
    }
    if (e?.value) {
      fields.map((field: any) => {
        if (e.name === field.systemFieldName) {
          field.enableRule = "";
        }
      });
    }
    sessionStorage.setItem("PhysicianID", e?.value);
    sessionStorage.setItem("PhysicianName", e?.label);

    setSelectedDropDownValue((preVal: any) => {
      return {
        ...preVal,
        selectedProvider: e,
      };
    });
  };

  const getCollectorNameList = async (facilityId: string) => {
    await RequisitionType.getCollectorsList(facilityId)
      .then((res: any) => {
        const InputsWithCollectorNameOption = collectorNameOptionsAdd(
          inputs,
          facilityId,
          res?.data
        );
        let InputsWithCollectorNameOptionCopy = [
          ...InputsWithCollectorNameOption,
        ];
        setInputs(InputsWithCollectorNameOptionCopy);
      })
      .catch((err: any) => {
        console.trace(err);
      });
  };

  return (
    <>
      {fields?.map((items: any, fieldIndex: any) => (
        <>
          <div className={`${items?.displayType} mb-4`}>
            {(items?.uiType === "DropDown" ||
              items?.uiType === "ProviderWithNoProviderCheckbox") &&
            items?.visible ? (
              <>
                {false && items?.systemFieldName === "PhysicianID" ? (
                  <label className="mb-2 fw-500"> </label>
                ) : (
                  <label
                    className={
                      items?.required &&
                      items.systemFieldName === "FacilityID" &&
                      _adminType == 2
                        ? ""
                        : `${items.systemFieldName === "PhysicianID" && providerNotRequired ? "" : "required"}  mb-2 fw-500`
                    }
                  >
                    {items.systemFieldName === "FacilityID" && _adminType == 2
                      ? null
                      : t(items?.displayFieldName)}
                  </label>
                )}
                <div className="col-lg-12">
                  {items?.systemFieldName === "PhysicianID" &&
                  items?.uiType === "DropDown" ? (
                    <>
                      <div className="row">
                        {items?.systemFieldName === "PhysicianID" ||
                        fields?.length === 2 ? (
                          <>
                            <div className="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-12">
                              <ProviderDropdown
                                physicianArr={physicianList}
                                onProviderSelect={onProviderSelect}
                                selectedProviders={
                                  selectedDropDownValue?.selectedProvider
                                }
                                name={items?.systemFieldName}
                                errorFocussedInput={errorFocussedInput}
                                setPhysicianList={setPhysicianList}
                                setPhysicianId={setPhysicianId}
                                items={items}
                                setErrorFocussedInput={setErrorFocussedInput}
                                error={items.enableRule}
                                inputs={inputs}
                                setInputs={setInputs}
                              />
                            </div>

                            <div
                              className={`col-xl-6 col-lg-6 col-md-6 col-sm-6 col-12`}
                            >
                              <button
                                type="button"
                                className="btn btn-light-primary btn-sm px-4 p-2 py-3 mt-2 mt-sm-0"
                                onClick={handleOpen}
                                disabled={providerNotRequired}
                              >
                                <i
                                  className="bi bi-plus"
                                  style={{ fontSize: "20px" }}
                                ></i>
                                {t("Add New Provider")}
                              </button>
                            </div>
                          </>
                        ) : null}
                      </div>
                    </>
                  ) : null}

                  {items?.systemFieldName === "PhysicianID" &&
                  items?.uiType === "ProviderWithNoProviderCheckbox" ? (
                    <>
                      <div className="row">
                        {items?.systemFieldName === "PhysicianID" ||
                        fields?.length === 2 ? (
                          <>
                            <div className="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-12">
                              <ProviderDropdown
                                physicianArr={physicianList}
                                onProviderSelect={onProviderSelect}
                                selectedProviders={
                                  selectedDropDownValue?.selectedProvider
                                }
                                name={items?.systemFieldName}
                                errorFocussedInput={errorFocussedInput}
                                setPhysicianList={setPhysicianList}
                                setPhysicianId={setPhysicianId}
                                items={items}
                                setErrorFocussedInput={setErrorFocussedInput}
                                error={items.enableRule}
                                providerNotRequired={providerNotRequired}
                                inputs={inputs}
                              />
                              <div className="mt-2">
                                <label className="form-check form-check-inline form-check-solid m-0 d-flex align-items-center gap-2">
                                  <input
                                    className="form-check-input h-15px w-15px rounded-01"
                                    type="checkbox"
                                    onChange={handleChange}
                                    checked={providerNotRequired}
                                  />
                                  <span className="text-gray-600 fs-7">
                                    {t("Provider Not Required")}
                                  </span>
                                </label>
                              </div>
                            </div>

                            <div
                              className={`col-xl-6 col-lg-6 col-md-6 col-sm-6 col-12`}
                            >
                              <button
                                type="button"
                                className="btn btn-light-primary btn-sm px-4 p-2 py-3 mt-2 mt-sm-0"
                                onClick={handleOpen}
                                disabled={providerNotRequired}
                              >
                                <i
                                  className="bi bi-plus"
                                  style={{ fontSize: "20px" }}
                                ></i>
                                {t("Add New Provider")}
                              </button>
                            </div>
                          </>
                        ) : null}
                      </div>
                    </>
                  ) : null}
                </div>
                <div className="col-lg-12">
                  {items?.systemFieldName === "FacilityID" ? (
                    <FacilityDropdown
                      facilityList={items.options}
                      onFacilitySelect={onFacilitySelect}
                      selectedFacilities={
                        selectedDropDownValue?.selectedFacility
                      }
                      name={items?.systemFieldName}
                      errorFocussedInput={errorFocussedInput}
                      setSelectedDropDownValue={setSelectedDropDownValue}
                      _adminType={_adminType}
                      items={items}
                      setErrorFocussedInput={setErrorFocussedInput}
                      error={items.enableRule}
                    />
                  ) : null}
                </div>
                {items.systemFieldName === "FacilityID" && _adminType == 2
                  ? null
                  : items.enableRule && (
                      <div className="form__error">
                        <span>{t(items.enableRule)}</span>
                      </div>
                    )}
              </>
            ) : null}
            {(items?.uiType === "TextBox" || items?.uiType === "TextArea") &&
            items?.visible ? (
              <>
                <label className="required mb-2 fw-500">
                  {t(items?.displayFieldName)}
                </label>
                <Input
                  label={items?.displayFieldName}
                  onChange={(e: any) => e.target.value}
                  required={items?.required}
                  setErrorFocussedInput={setErrorFocussedInput}
                  error={items.enableRule}
                  errorFocussedInput={errorFocussedInput}
                />
              </>
            ) : null}
            {items?.uiType === "CheckBox" && items?.visible ? (
              <>
                <Checkbox
                  spanClassName="ms-3"
                  labelClassName="form-check form-check-inline form-check-solid m-0 fw-500"
                  label={t(items?.displayFieldName)}
                  setErrorFocussedInput={setErrorFocussedInput}
                  error={items.enableRule}
                  errorFocussedInput={errorFocussedInput}
                  sectionName={props?.section?.sectionName}
                  parentDivClassName={items?.displayType}
                  systemFieldName={items?.systemFieldName}
                  onChange={async (e: any) => {
                    items.enableRule = "";
                    let newInputs = await assignFormValues(
                      inputs,
                      index,
                      undefined,
                      fieldIndex,
                      //e.target.checked,
                      true,
                      false,
                      false,
                      false,
                      undefined,
                      undefined,
                      undefined,
                      e.target.label,
                      setInputs
                    );

                    setInputs(newInputs);
                  }}
                  sectionId={props.sectionId}
                  defaultValue={items?.defaultValue}
                  Inputs={inputs}
                  setInputs={setInputs}
                  index={index}
                />
              </>
            ) : null}
            {items?.uiType === "DropDown" &&
            items.systemFieldName != "FacilityID" &&
            items?.visible &&
            items?.uiType === "DropDown" &&
            items.systemFieldName != "PhysicianID" &&
            items?.visible ? (
              <>
                <Select
                  menuPortalTarget={document.body}
                  inputId={items.systemFieldName}
                  options={items.options}
                  placeholder={t(items?.displayFieldName)}
                  theme={(theme) => styles(theme)}
                  value={setDropDownValue(
                    items.options,
                    items?.defaultValue,
                    requisitionId
                  )}
                  onChange={async (e: any) => {
                    fields.enableRule = "";
                    let newInputs = await assignFormValues(
                      inputs,
                      index,
                      undefined,
                      0,
                      e.value,
                      false,
                      false,
                      false,
                      undefined,
                      undefined,
                      undefined,
                      e.label,
                      setInputs
                    );
                    if (props.ArrayReqId) {
                      const infectiousDataCopy = [...props?.infectiousData];
                      infectiousDataCopy[
                        FindIndex(infectiousDataCopy, props.ArrayReqId)
                      ].sections = newInputs;
                      props?.setInfectiousData &&
                        props?.setInfectiousData([...infectiousDataCopy]);
                    } else {
                      props?.setInputs(newInputs);
                    }
                  }}
                  isSearchable={true}
                  styles={{
                    control: (baseStyles, state) => ({
                      ...baseStyles,
                      borderColor: "var(--kt-input-border-color)",
                      color: "var(--kt-input-border-color)",
                    }),
                  }}
                  id={items?.displayFieldName.split(" ").join("")}
                />
              </>
            ) : null}
          </div>
        </>
      ))}
      {/* modalstart */}
      <Popup
        open={open}
        handleClose={handleClose}
        isShown={isShown}
        index={index}
        setIsShown={setIsShown}
        inputs={inputs}
        setInputs={setInputs}
        setSelectedDropDownValue={setSelectedDropDownValue}
        selectedDropDownValue={selectedDropDownValue}
        dependenceyControls={dependenceyControls}
        setPhysicianList={setPhysicianList}
        physicianList={physicianList}
        onFacilitySelect={onFacilitySelect}
        fields={fields}
        getCollectorNameList={getCollectorNameList}
        ProviderLookup={ProviderLookup}
      />
    </>
  );
};
function mapStateToProps(state: any, ownProps: any) {
  return { RequsitionData: state };
}
export default connect(mapStateToProps)(GroupedSelect);
